module.exports = __webpack_public_path__ + "static/15-2512c62a90c77e638e0eff232a5920d0.jpg";